import { createBrowserRouter } from "react-router";
import { preparePreloadableRoutes } from "@loop-payments/react-router-relay";
import { routes } from "../app/routes";
import { RootLayout } from "./RootLayout";
import { environment } from "../relay/environment";

// Environment provider for preparePreloadableRoutes
const environmentProvider = {
  getEnvironment: () => environment,
};

// Prepare routes with entrypoint support (allows gradual migration)
const preparedRoutes = preparePreloadableRoutes(routes, environmentProvider);

// Wrap all routes in the RootLayout which provides the necessary context providers
const routesWithLayout = [
  {
    element: <RootLayout />,
    children: preparedRoutes,
  },
];

export const router = createBrowserRouter(routesWithLayout);
